var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-280 372 50 50",
    style: {
      enableBackground: "new -280 372 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\r\n\t.st0{fill:#5D5D5D;}\r\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1_",
    className: "st0",
    points: "-252,387.7 -248.8,379.6 -231,422.1 -237.4,422.1 -242.6,409.6 -261,409.6  -258.6,404.1 -245.3,404.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st0",
    points: "-246.6,416.2 -244.4,422.1 -279,422.1 -258.2,371.9 -251.4,371.9 -269.6,416.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/companyIcon.049c62efb19406acc9153409940296bd.svg";
export { ForwardRef as ReactComponent };